<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-5 mx-0 no-gutter">
        <back-button :returnUrl = "returnUrl"></back-button>
      </b-row>
      <remote-folder-configuration-form v-model="config" :readonly="!editMode"></remote-folder-configuration-form>
      <b-row class="justify-content-end mt-3 no-gutters">
        <b-button v-if="mode === 'create'"
        @click="createConfig" variant="primary">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
        <b-button class="mr-3" v-if="mode === 'details' && editMode === false && canEditConfig"
        @click="editModeActivate" variant="primary">
          <span>{{$t('common.routing.edit_this_config')}}</span>
        </b-button>
        <b-button class="mr-3" v-if="mode === 'details' && editMode === false && canDeleteConfig"
        @click="deleteConfig" variant="primary">
          <i class="fa-light fa-trash"></i>
          <span>{{$t('common.routing.delete_config')}}</span>
        </b-button>
        <b-button variant="primary" v-if="mode === 'details' && editMode === true"
          @click="editConfig">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import RemoteFolderConfigurationForm from '@/pages/routing/RemoteFolderConfigurationForm.vue'

import {loadPage} from '@/helpers/routing'

export default {
  name: 'MessageDetails',
  components: {
    'back-button': backButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'remote-folder-configuration-form': RemoteFolderConfigurationForm,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "create"
    }
  },
  computed: {
    canDeleteConfig () {
      return this.$engine.rights.rightIs('remoteFolderConfig_supprimer', true)
    },
    canEditConfig () {
      return this.$engine.rights.rightIs('remoteFolderConfig_editer', true)
    },
    pageTitle () {
      return this.mode === "details" ? this.$t('Webheader.remotefolder_details') : this.$t('Webheader.remotefolder_add')
    },
  },
  data () {
    return {
      activateSpinner: false,
      editMode: false,
      name: '',
      path: '',
      returnUrl: '/routing/configurationList/REMOTEFOLDER',
      savedConfig: [],
      config: {}
    }
  },
  created () {
    this.activateSpinner = true

    if (this.mode === "details") {
      this.savedConfig = this.$engine.routing.config.clickedConfig
      this.fillFields()
      this.$engine.routing.config.clickedConfig = {}
    } else {
      this.editMode = true
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
  },
  methods: {
    createConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Path: this.config.path,
        Name: this.config.name
      }
      this.$engine.routing.config.remoteFolder.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.config_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/configurationList/REMOTEFOLDER'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.routing.config_addition_error'))
      })
    },
    deleteConfig () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.config_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdRemoteFolder: that.savedConfig.IdRemoteFolder
              }
              that.$engine.routing.config.remoteFolder.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.config_deleted'))
                loadPage(that, {url: '/routing/configurationList/REMOTEFOLDER'})
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Path: this.config.path,
        Name: this.config.name,
        IdRemoteFolder: this.savedConfig.IdRemoteFolder
      }
      this.$engine.routing.config.remoteFolder.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.config_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/configurationList/REMOTEFOLDER'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.routing.config_edition_error'))
      })
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.config.name = this.savedConfig.Name
      this.config.path = this.savedConfig.Path
    },
    formHasError () {
      if (this.config.name === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
        return true
      }
      if (this.config.path === undefined || this.config.path.length === 0) {
        this.okMessageBox(this.$t('common.routing.path_missing'))
        return true
      }
      return false
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
      else {
        loadPage(this, {url: '/routing/configurationList/REMOTEFOLDER'})
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
